module.exports = __webpack_public_path__ + "static/media/SpikeForest_Short.e301186a.jpg";